<template>
    <div id="Section-02" class="section-02 wsl-flex-center-ng">
        <div class="container wsl-relative s02bg" :style="{backgroundImage: `url(${s02Bg1}`}"
             style="
                    background-repeat: no-repeat;
                    background-position: center center;">

            <div class="cb-bg-blue block-header wsl-p-y-10 wsl-show-sm wsl-show-xs">
                <div class="wsl-flex-middle-ng">
                    <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">02
                    </div>
                    <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">Достижения</div>
                </div>
            </div>

            <div class="wsl-show-sm wsl-show-xs wsl-m-t-40">
                <div class="wsl-flex-middle-ng">
                    <div class="wsl-text-left wsl-p-x-30" style="line-height: 1.2;">
                        <div>
                            <span class="Oswald-Light cb-cyan t48">Надежность и </span>
                            <span class="Oswald-Light cb-blue t48">высокие стандарты</span>
                        </div>
                        <div class="Roboto t16 cb-grey wsl-m-t-15">нашей работы многократно подтверждены
                            дипломами ведущих туроператоров России
                        </div>
                    </div>
                </div>
            </div>

            <div class="wsl-show-md wsl-p-y-30"></div>

            <img alt="" class="wsl-w-100 wsl-h-100 wsl-hide-sm wsl-hide-xs"
                 src="../assets/img/s02-bg1.png">

            <div class="wsl-abs wsl-hide-sm wsl-hide-xs" style="
                    background-color: #0056cd;
                    opacity: 0.2;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: top left;
                    top: 4%; right: 16.75%; width: 20.63%; height: 26.84%;">
            </div>

            <div class="wsl-abs wsl-hide-sm wsl-hide-xs"
                 :style="{backgroundImage: `url(${s02Bg2}`}"
                 style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: top right;
                    top: -8%; right: 6.29%; width: 27.1%; height: 26%;">
                <div class="wsl-w-100 wsl-h-100">
                    <div class="wsl-w-100 wsl-h-100 wsl-flex-middle-ng" style="padding-left: 11.9%;">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">02
                        </div>
                        <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">Достижения</div>
                    </div>
                </div>
            </div>

            <div class="wsl-abs wsl-hide-sm wsl-hide-xs"
                 :style="{backgroundImage: `url(${blueBox}`}"
                 style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; left: 0; width: 33.34%; height: 12.6%;">

            </div>

            <div class="wsl-abs wsl-abs-top wsl-m-l-55 wsl-show-md wsl-w-60">
                <div class="wsl-flex-middle-ng wsl-h-100">
                    <div class="wsl-text-left wsl-p-x-30" style="line-height: 1.2;">
                        <div>
                            <span class="Oswald-Light cb-cyan t48">Надежность и </span>
                            <span class="Oswald-Light cb-blue t48">высокие стандарты</span>
                        </div>
                        <div class="Roboto t16 cb-grey wsl-m-t-15">нашей работы многократно подтверждены
                            дипломами ведущих туроператоров России
                        </div>
                    </div>
                </div>
            </div>

            <div class="wsl-abs wsl-flex-ng wsl-w-100 s02-swiper">
                <div class="wsl-col-8_from-sm-12">
                    <swiper :options="swiperOptionDiploms" ref="dipSwiper">
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/alean2016-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/ambotis2017-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/anex2016-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/bg2017-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/coral2017-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/evroport2017-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/express2016-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/ics1016-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/intourist2017-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/mouzik2016-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="wsl-p-x-15 wsl-p-y-30">
                                <div class="diplom-shadow">
                                    <img alt=""
                                         class="responsive-img"
                                         src="../assets/img/diploms/tez2017-min.jpg">
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="wsl-col-4 wsl-hide-md wsl-hide-sm wsl-hide-xs">
                    <div class="wsl-flex-middle-ng wsl-h-100">
                        <div class="wsl-text-left wsl-p-x-30" style="line-height: 1.2;">
                            <div>
                                <span class="Oswald-Light cb-cyan t48">Надежность и </span>
                                <span class="Oswald-Light cb-blue t48">высокие стандарты</span>
                            </div>
                            <div class="Roboto t16 cb-grey wsl-m-t-15">нашей работы многократно подтверждены
                                дипломами ведущих туроператоров России
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="wsl-abs wsl-abs-top wsl-w-100 wsl-h-100">
                <div class="wsl-relative wsl-w-100 wsl-h-100">
                    <div class="wsl-abs dip-swiper-pagination" slot="pagination"
                         style="bottom: 4.5%; right: auto;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Section-02',
  props: {
    blueBox: String,
    s02Bg1: String,
    s02Bg2: String,
    s02Bg3: String
  },
  data () {
    return {
      swiperOptionDiploms: {
        slidesPerView: 3,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.dip-swiper-pagination',
          clickable: true
        },
        breakpoints: {
          5000: {
            slidesPerView: 4
          },
          1600: {
            slidesPerView: 3
          },
          1366: {
            slidesPerView: 3
          },
          1280: {
            slidesPerView: 3
          },
          991: {
            slidesPerView: 3
          },
          768: {
            slidesPerView: 3
          },
          375: {
            slidesPerView: 1
          }
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.dipSwiper.swiper
    }
  }
}
</script>

<style scoped>

</style>
